import { cva } from 'class-variance-authority'
import type { FC } from 'react'

import { ThemeIcon } from '../../../../ThemeIcon/base/ThemeIcon'

import type { TimelineBadgeProps } from './TimelineBadge.types'

const timelineItemCVA = {
  root: cva(['w-fit gap-4'])
}

export const TimelineBadge: FC<TimelineBadgeProps> = ({ icon, ...other }) => (
  <ThemeIcon
    size='s'
    className={timelineItemCVA.root()}
    {...other}
    icon={icon}
  />
)
